/* Used by Storefront */

import React from "react";
import { LinkedResourceResult } from "~/common/Store/models/Category";
import VideoResource from "./VideoResource";
import TextResource from "./TextResource";
interface Props {
  linkedResources: LinkedResourceResult[];
}
const FeaturedResources = ({
  linkedResources
}: Props) => {
  const featuredLinkedResources = linkedResources.filter(x => x.isFeatured === true && x.type !== "User Review");
  const numberOfFeaturedItemsToDisplay = 3;
  const DisplayResource = (resource: LinkedResourceResult, index: number) => {
    return resource.type === "Video" ? <VideoResource resource={resource} key={resource.title} data-sentry-element="VideoResource" data-sentry-component="DisplayResource" data-sentry-source-file="FeaturedResources.tsx" /> : <TextResource index={index} resource={resource} key={resource.title} data-sentry-element="TextResource" data-sentry-component="DisplayResource" data-sentry-source-file="FeaturedResources.tsx" />;
  };
  return <div className="clears fsr-content" data-sentry-component="FeaturedResources" data-sentry-source-file="FeaturedResources.tsx">
      {featuredLinkedResources.slice(0, numberOfFeaturedItemsToDisplay).map((resource: LinkedResourceResult, index) => DisplayResource(resource, index))}
    </div>;
};
export default FeaturedResources;